// extracted by mini-css-extract-plugin
export default {"plugin_view":"AssetItem_plugin_view__KWvfO","heading":"AssetItem_heading__ke-Z7"};